module.exports = __webpack_public_path__ + "website/img/dl_book.d40a0a84.png";